// ============================================================================
// ToolbarAddMenu — the header "Add new" button when a screen creates more than
// one kind of document (e.g. Credit Note / Debit Note, ADR-0053).
// ============================================================================
// Looks exactly like actionButtonFactory.add (32px bordered icon box, 18px
// "+", tooltip), so the header stays uniform; a click opens the standard
// action-menu dropdown to pick the kind. Pass it via customToolbarItems.

import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import { ActionMenu, type ActionMenuItem } from 'components/ui';

interface ToolbarAddMenuProps {
  id: string;
  items: ActionMenuItem[];
  /** Tooltip on the button — defaults to the template's "Add new". */
  tooltip?: string;
}

export const ToolbarAddMenu: React.FC<ToolbarAddMenuProps> = ({ id, items, tooltip = 'Add new' }) => {
  if (items.length === 0) return null;
  return (
    <span title={tooltip} style={{ display: 'inline-flex' }}>
      <ActionMenu id={id} items={items} position="bottom-left" triggerClassName="toolbar-add-trigger"
        triggerContent={<IconSystem.add size={18} />} />
    </span>
  );
};

export default ToolbarAddMenu;
